import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './utils/auth';
import { Layout } from './components/Layout';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { TechnicienDashboard } from './pages/TechnicienDashboard';
import { Clients } from './pages/Clients';
import { ClientDetail } from './pages/ClientDetail';
import { ChantiersList } from './pages/ChantiersList';
import { ChantierDetail } from './pages/ChantierDetail';
import { NewChantier } from './pages/NewChantier';
import { EditChantier } from './pages/EditChantier';
import { Validations } from './pages/Validations';
import { Team } from './pages/Team';
import { Settings } from './pages/Settings';
function ProtectedRoute({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    isAuthenticated
  } = useAuth();
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" data-id="element-0" />;
}
function AppRoutes() {
  const {
    user,
    isAuthenticated
  } = useAuth();
  if (!isAuthenticated) {
    return <Routes data-id="element-1">
        <Route path="/login" element={<Login data-id="element-3" />} data-id="element-2" />
        <Route path="*" element={<Navigate to="/login" data-id="element-5" />} data-id="element-4" />
      </Routes>;
  }
  // Technicien - simplified interface
  if (user?.role === 'technicien') {
    return <Routes data-id="element-6">
        <Route path="/" element={<Layout data-id="element-8" />} data-id="element-7">
          <Route index element={<TechnicienDashboard data-id="element-10" />} data-id="element-9" />
          <Route path="chantiers/:id" element={<ChantierDetail data-id="element-12" />} data-id="element-11" />
          <Route path="*" element={<Navigate to="/" data-id="element-14" />} data-id="element-13" />
        </Route>
      </Routes>;
  }
  // Chef d'équipe - simplified with validations
  if (user?.role === 'chef_equipe') {
    return <Routes data-id="element-15">
        <Route path="/" element={<Layout data-id="element-17" />} data-id="element-16">
          <Route index element={<TechnicienDashboard data-id="element-19" />} data-id="element-18" />
          <Route path="chantiers/:id" element={<ChantierDetail data-id="element-21" />} data-id="element-20" />
          <Route path="validations" element={<Validations data-id="element-23" />} data-id="element-22" />
          <Route path="*" element={<Navigate to="/" data-id="element-25" />} data-id="element-24" />
        </Route>
      </Routes>;
  }
  // Direction - view only (no create/edit)
  if (user?.role === 'direction') {
    return <Routes data-id="element-26">
        <Route path="/" element={<Layout data-id="element-28" />} data-id="element-27">
          <Route index element={<Dashboard data-id="element-30" />} data-id="element-29" />
          <Route path="clients" element={<Clients data-id="element-32" />} data-id="element-31" />
          <Route path="clients/:id" element={<ClientDetail data-id="element-34" />} data-id="element-33" />
          <Route path="chantiers" element={<ChantiersList data-id="element-36" />} data-id="element-35" />
          <Route path="chantiers/:id" element={<ChantierDetail data-id="element-38" />} data-id="element-37" />
          <Route path="team" element={<Team data-id="element-40" />} data-id="element-39" />
          <Route path="*" element={<Navigate to="/" data-id="element-42" />} data-id="element-41" />
        </Route>
      </Routes>;
  }
  // Bureau and Admin - full access
  return <Routes data-id="element-43">
      <Route path="/" element={<Layout data-id="element-45" />} data-id="element-44">
        <Route index element={<Dashboard data-id="element-47" />} data-id="element-46" />
        <Route path="clients" element={<Clients data-id="element-49" />} data-id="element-48" />
        <Route path="clients/:id" element={<ClientDetail data-id="element-51" />} data-id="element-50" />
        <Route path="chantiers" element={<ChantiersList data-id="element-53" />} data-id="element-52" />
        <Route path="chantiers/new" element={<NewChantier data-id="element-55" />} data-id="element-54" />
        <Route path="chantiers/:id" element={<ChantierDetail data-id="element-57" />} data-id="element-56" />
        <Route path="chantiers/:id/edit" element={<EditChantier data-id="element-59" />} data-id="element-58" />
        <Route path="validations" element={<Validations data-id="element-61" />} data-id="element-60" />
        <Route path="team" element={<Team data-id="element-63" />} data-id="element-62" />
        {user?.role === 'admin' && <Route path="settings" element={<Settings data-id="element-65" />} data-id="element-64" />}
        <Route path="*" element={<Navigate to="/" data-id="element-67" />} data-id="element-66" />
      </Route>
    </Routes>;
}
export function App() {
  return <AuthProvider data-id="element-68">
      <Router data-id="element-69">
        <AppRoutes data-id="element-70" />
      </Router>
    </AuthProvider>;
}